import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Sidebar from '../Sidebar/Sidebar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faUserPlus, faTrash, faIdBadge } from '@fortawesome/free-solid-svg-icons';
import { buildApiUrl } from '../../config/api.config';

const StaffManagement = () => {
  const [staffList, setStaffList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formVisible, setFormVisible] = useState(false);
  const [newStaff, setNewStaff] = useState({ name: '', email: '', password: '', staffRole: 'chef' });
  const [error, setError] = useState(null);

  const fetchStaff = async () => {
    try {
      const restaurantId = localStorage.getItem('currentRestaurantId');
      const token = localStorage.getItem('token');
      
      const response = await axios.post(buildApiUrl("staff/list"), { restaurantId }, {
        headers: { 'auth-token': token }
      });
      setStaffList(response.data);
    } catch (err) {
      console.error("Error fetching staff:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStaff();
  }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      const restaurantId = localStorage.getItem('currentRestaurantId');
      const token = localStorage.getItem('token');

      await axios.post(buildApiUrl("staff/create"), { ...newStaff, restaurantId }, {
        headers: { 'auth-token': token }
      });

      setFormVisible(false);
      setNewStaff({ name: '', email: '', password: '', staffRole: 'chef' });
      fetchStaff();
    } catch (err) {
      setError(err.response?.data?.message || "Failed to create staff");
    }
  };

  const handleDelete = async (staffId) => {
    if (!window.confirm("Are you sure you want to remove this staff member?")) return;
    try {
      const token = localStorage.getItem('token');
      await axios.delete(buildApiUrl(`staff/${staffId}`), {
         headers: { 'auth-token': token }
      });
      fetchStaff();
    } catch (err) {
      console.error("Error removing staff:", err);
    }
  };

  return (
    <div style={{ display: 'flex', height: '100vh', background: '#0a0a0c', color: 'white' }}>
      <Sidebar />
      <div style={{ flex: 1, padding: '2rem', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
          <h1 style={{ fontSize: '2rem', fontWeight: '800' }}>
            <FontAwesomeIcon icon={faUsers} style={{ marginRight: '1rem', color: '#ff4135' }} />
            Team Management
          </h1>
          <button 
            onClick={() => setFormVisible(!formVisible)}
            style={{ padding: '0.8rem 1.5rem', background: '#ff4135', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}
          >
            <FontAwesomeIcon icon={faUserPlus} style={{ marginRight: '0.5rem' }} /> Add Staff
          </button>
        </div>

        {formVisible && (
          <div style={{ background: '#1c1c1f', padding: '1.5rem', borderRadius: '12px', marginBottom: '2rem', border: '1px solid rgba(255,255,255,0.1)' }}>
            <h3 style={{ marginTop: 0 }}>Add New Staff Member</h3>
            {error && <p style={{ color: 'red' }}>{error}</p>}
            <form onSubmit={handleCreate} style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
              <input 
                placeholder="Name" 
                value={newStaff.name} 
                onChange={e => setNewStaff({...newStaff, name: e.target.value})} 
                required
                style={{ flex: 1, padding: '0.8rem', borderRadius: '6px', border: 'none', background: 'rgba(255,255,255,0.05)', color: 'white' }}
              />
              <input 
                placeholder="Email" 
                type="email"
                value={newStaff.email} 
                onChange={e => setNewStaff({...newStaff, email: e.target.value})} 
                required
                style={{ flex: 1, padding: '0.8rem', borderRadius: '6px', border: 'none', background: 'rgba(255,255,255,0.05)', color: 'white' }}
              />
              <input 
                placeholder="Password" 
                type="password"
                value={newStaff.password} 
                onChange={e => setNewStaff({...newStaff, password: e.target.value})} 
                required
                style={{ flex: 1, padding: '0.8rem', borderRadius: '6px', border: 'none', background: 'rgba(255,255,255,0.05)', color: 'white' }}
              />
              <select 
                value={newStaff.staffRole}
                onChange={e => setNewStaff({...newStaff, staffRole: e.target.value})}
                style={{ padding: '0.8rem', borderRadius: '6px', border: 'none', background: 'rgba(255,255,255,0.05)', color: 'white' }}
              >
                <option value="chef">👨‍🍳 Chef</option>
                <option value="waiter">🤵 Waiter</option>
                <option value="manager">👔 Manager</option>
              </select>
              <button type="submit" style={{ padding: '0.8rem 2rem', background: 'white', color: 'black', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>Create</button>
            </form>
          </div>
        )}

        {loading ? (
          <div>Loading staff...</div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '1.5rem' }}>
            {staffList.map(staff => (
              <div key={staff._id} style={{ background: '#1c1c1f', padding: '1.5rem', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.05)', position: 'relative' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
                  {staff.profilePhoto ? (
                    <img 
                      src={staff.profilePhoto} 
                      alt={staff.name}
                      style={{ 
                        width: '50px', 
                        height: '50px', 
                        borderRadius: '12px', 
                        objectFit: 'cover',
                        border: '2px solid rgba(255,65,53,0.3)'
                      }} 
                    />
                  ) : (
                    <div style={{ width: '50px', height: '50px', background: 'rgba(255,65,53,0.1)', color: '#ff4135', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem' }}>
                      <FontAwesomeIcon icon={faIdBadge} />
                    </div>
                  )}
                  <div>
                    <h3 style={{ margin: 0 }}>{staff.name}</h3>
                    <p style={{ margin: 0, color: 'rgba(255,255,255,0.5)', fontSize: '0.9rem', textTransform: 'capitalize' }}>{staff.staffRole}</p>
                  </div>
                </div>
                <div style={{ background: 'rgba(0,0,0,0.2)', padding: '0.8rem', borderRadius: '8px', fontSize: '0.9rem', color: 'rgba(255,255,255,0.7)', marginBottom: '1rem' }}>
                   {staff.email}
                </div>
                <button 
                  onClick={() => handleDelete(staff._id)}
                  style={{ width: '100%', padding: '0.8rem', background: 'rgba(255,0,0,0.1)', color: '#ff4135', border: 'none', borderRadius: '8px', cursor: 'pointer', transition: '0.2s' }}
                >
                  <FontAwesomeIcon icon={faTrash} /> Remove Access
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default StaffManagement;
